//src/pages/components/header.js

import React from "react"
import { useStaticQuery, Link, graphql } from "gatsby"
import "../styles/scss/header.scss"

export default ( ) => {
     const data = useStaticQuery(
       graphql`
       query {
         site {
           siteMetadata {
             title
            }
          }
        }
        `
        )
      return (

    <section className="header">
    <div className="nav-container">
      <div className="brand">
        <Link to="/">
        <h3>{data.site.siteMetadata.title}</h3>
        </Link>
      </div>
      <nav>
        <ul className="main-nav">
          <Link to="/">Home</Link>
          <Link to="/about/">About</Link>
          <Link to="/contact/">Contact</Link>
        </ul>
      </nav>
  </div>
  </section>
)
}
